import { Navigate } from 'react-router-dom';

const ContributeRedirect = () => {
    return <Navigate to="/contribute/reason" replace />;
};

export default ContributeRedirect;
